import { render, staticRenderFns } from "./AddDataPopup.vue?vue&type=template&id=77e5b1d2"
import script from "./AddDataPopup.vue?vue&type=script&lang=js"
export * from "./AddDataPopup.vue?vue&type=script&lang=js"
import style0 from "./AddDataPopup.vue?vue&type=style&index=0&id=77e5b1d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports